import React, { useState } from "react";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { BLOCKS } from "@contentful/rich-text-types";

// Components //
import Slider from "react-slick";
import TitleSection from "../../molecules/title-section";

import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";

// Styles //
import "./our-projects.scss";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const OurProjects = (props: ReferenciaContenido) => {
    const { tituloGeneral, referenciaPlantillaContenido: refPlantilla } = props;
    const [slider, setSlider] = useState<any>();
    const [sliderIndex, setSliderIndex] = useState(0);

    const CarouselProjects = {
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        waitForAnimate: false,
        autoplay: false,
        fade: false,
        autoplaySpeed: 10000,
        beforeChange: (_: number, next: number) => setSliderIndex(next),
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    initialSlide: 1,
                },
            },
            {
                breakpoint: 570,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    const goToNext = () => {
        if (sliderIndex < refPlantilla.length - 1) {
            setSliderIndex(sliderIndex + 1);
            slider.slickNext();
        }
    };

    const goToBack = () => {
        if (sliderIndex > 0) {
            setSliderIndex(sliderIndex - 1);
            slider.slickPrev();
        }
    };

    const isActiveBack = () => sliderIndex > 0;

    const isActiveNext = () => sliderIndex < refPlantilla.length - 1;

    //Bloque creado para google tag manager//
	const gtmBasedOnTitle = (counter) =>{
		return counter === 0 ?
               `gtm_proyecto_empresas_alianza`
               : counter === 1 ?
               `gtm_proyecto_empresas_creo`
               : counter === 2 ?
               `gtm_proyecto_empresas_portalento`
               : ''

	}
	//Bloque creado para google tag manager//

    // Funcion para renderizar contenido de texto de tipo json provenientes de contentful
    const contentfulRenderOptions = (index) =>{
        const contentfulRender = {
            renderNode: {
                [BLOCKS.PARAGRAPH]: (node, children) => {
                    return <p className={gtmBasedOnTitle(index)}> {children} </p> 
                },
            },
            renderText: (text) =>
            text.split("\n").flatMap((txt, i) => [i > 0 && <br />, txt]),
        }
        return contentfulRender
    }

    return (
        <div className="o-our-projects">
            <div className="container">
                <TitleSection title={tituloGeneral} />
                <div className="o-our-projects__container">
                    <Slider
                        ref={(c) => {
                            setSlider(c);
                        }}
                        {...CarouselProjects}
                    >
                        {refPlantilla.map((item, i) => (
                            <a
                                href={item.redireccionBoton}
                                target="_blank"
                                className="our-projects-item"
                                rel="noreferrer"
                                key={i}
                            >
                                <div className="our-projects-item__image">
                                    <img className={gtmBasedOnTitle(i)}
                                        src={item.imagenPrincipal[0].file.url}
                                        alt={item.tituloBanner}
                                    />
                                </div>
                                <div className="our-projects-item__text">
                                    <h3 className ={gtmBasedOnTitle(i)}>
                                        {item.tituloBanner}
                                    </h3>
                                    {item.descripcion.json &&
                                        documentToReactComponents(
                                            item.descripcion.json,
                                            contentfulRenderOptions(i)
                                        )}
                                </div>
                            </a>
                        ))}
                    </Slider>
                    <span
                        className={`arrow icon-chevron-left ${
                            isActiveBack() ? "active" : ""
                        }`}
                        onClick={goToBack}
                    ></span>
                    <span
                        className={`arrow  icon-chevron-right  ${
                            isActiveNext() ? "active" : ""
                        }`}
                        onClick={goToNext}
                    ></span>
                </div>
            </div>
        </div>
    );
};

export default OurProjects;
